var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddPhotoAlternate24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.5v4.485s-2.985.015-3 0V7.5h-4.5s.015-2.985 0-3H21V0h3v4.5h4.5v3H24zm-4.5 6V9H15V4.5H3c-1.65 0-3 1.35-3 3v18c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3v-12h-4.5zM3 25.5l4.5-6 3 4.5 4.5-6 6 7.5H3z",
    fill: "#DE3530",
    fillRule: "nonzero"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhotoAlternate24Px);
export default __webpack_public_path__ + "static/media/add-photo-alternate-24-px.bda0370f0e586e9af931c8f2ddfa3355.svg";
export { ForwardRef as ReactComponent };